/** Room floor grid for furniture placement. */
export const HOME_GRID_COLS = 18;
export const HOME_GRID_ROWS = 10;
export const HOME_CELL_PX = 48;

export const HOME_GRID_COLS_MIN = 8;
export const HOME_GRID_COLS_MAX = 40;
export const HOME_GRID_ROWS_MIN = 6;
export const HOME_GRID_ROWS_MAX = 24;

/** Older defaults — migrate saved rooms that still use them. */
export const HOME_GRID_LEGACY_SIZES: ReadonlyArray<{ cols: number; rows: number }> = [
  { cols: 14, rows: 8 },
  { cols: 28, rows: 16 },
];

export const HOME_PART_CELLS_MIN = 1;
export const HOME_PART_CELLS_MAX = 4;

export function clampGridCols(n: number): number {
  if (!Number.isFinite(n)) return HOME_GRID_COLS;
  return Math.min(HOME_GRID_COLS_MAX, Math.max(HOME_GRID_COLS_MIN, Math.floor(n)));
}

export function clampGridRows(n: number): number {
  if (!Number.isFinite(n)) return HOME_GRID_ROWS;
  return Math.min(HOME_GRID_ROWS_MAX, Math.max(HOME_GRID_ROWS_MIN, Math.floor(n)));
}

export function homeGridPixelSize(
  cols = HOME_GRID_COLS,
  rows = HOME_GRID_ROWS,
): { width: number; height: number } {
  return {
    width: clampGridCols(cols) * HOME_CELL_PX,
    height: clampGridRows(rows) * HOME_CELL_PX,
  };
}
